import styled from "styled-components";

export const ContainerStepper = styled.div`
	#RFS-StepperContainer {
		font-family: var(--font-family-metropolis);
		font-weight: 700;

		width: 100%;
		padding: 24px 0;

		@media only screen and (max-width: 800px) {
			padding: 0;
		}
	}

	#RFS-StepContainer {
		padding: 0;
	}

	#RFS-StepButton {
		font-size: 12px;
		font-family: var(--font-family-metropolis);
		font-weight: 700;

		&:focus {
			outline: unset;
		}

		@media only screen and (max-width: 800px) {
			height: 16px;
			width: 16px;

			margin-top: 3px;
		}
	}

	#RFS-Label {
		color: var(--neutral-smoothest);
		min-width: 4.688rem;

		@media only screen and (max-width: 800px) {
			margin-top: 12px;
		}
	}
`;
